module.exports = __webpack_public_path__ + "img/2.6d3ecae4.png";